// app/javascript/controllers/affirm_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { 
        amount: Number,
        publicApiKey: String,
        environment: String
    }

    connect() {
        this.initializeAffirm()
        this.updateDom()
        this.refreshAffirm()
        
        // Fallback: Show element after a delay if Affirm doesn't load
        setTimeout(() => {
            if (this.element.style.opacity === '0') {
                this.element.style.opacity = '1'
            }
        }, 2000)
    }

    /**
     * Initialize Affirm SDK with credentials from Rails
     */
    initializeAffirm() {
        // Only initialize if Affirm hasn't been loaded yet and we have credentials
        if (typeof window.affirm === 'undefined' && this.hasPublicApiKeyValue) {
            const environment = this.environmentValue || 'sandbox'
            const scriptUrl = environment === 'production' 
                ? 'https://cdn1.affirm.com/js/v2/affirm.js'
                : 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js'

            window._affirm_config = {
                public_api_key: this.publicApiKeyValue,
                script: scriptUrl,
                locale: "en_US",
                country_code: "USA"
            }

            // Load Affirm SDK
            this.loadAffirmSDK()
        }
    }

    /**
     * Load Affirm SDK script dynamically
     */
    loadAffirmSDK() {
        (function (m, g, n, d, a, e, h, c) {
            var b = m[n] || {}, k = document.createElement(e), p = document.getElementsByTagName(e)[0], l = function (a, b, c) {
                return function () {
                    a[b]._.push([c, arguments])
                }
            };
            b[d] = l(b, d, "set");
            var f = b[d];
            b[a] = {};
            b[a]._ = [];
            f._ = [];
            b._ = [];
            b[a][h] = l(b, a, h);
            b[c] = function () {
                b._.push([h, arguments])
            };
            a = 0;
            for (c = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < c.length; a++) f[c[a]] = l(b, d, c[a]);
            a = 0;
            for (c = ["get", "token", "url", "items"]; a < c.length; a++) f[c[a]] = function () {
            };
            k.async = !0;
            k.src = g[e];
            p.parentNode.insertBefore(k, p);
            delete g[e];
            f(g);
            m[n] = b
        })(window, window._affirm_config, "affirm", "checkout", "ui", "script", "ready", "jsReady");
    }

    amountValueChanged() {
        this.updateDom()
        this.refreshAffirm()
    }

    updateDom() {
        // Keep the data-amount attribute in sync for Affirm
        this.element.setAttribute("data-amount", String(this.amountValue || 0))
    }

    refreshAffirm() {
        if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") {
            window.affirm.ui.ready(() => {
                window.affirm.ui.refresh()
                // Fade in the Affirm element once content is loaded
                this.fadeIn()
            })
        } else {
            // If Affirm isn't loaded yet, show the element anyway after a delay
            setTimeout(() => this.fadeIn(), 1000)
        }
    }
    
    fadeIn() {
        setTimeout(() => {
            this.element.style.opacity = '1'
        }, 100)
    }
    
    show() {
        // Method to show the Affirm element (can be triggered by action)
        this.element.style.opacity = '1'
    }

    /**
     * Open Affirm checkout modal with checkout data
     * @param {Object} checkoutData - The Affirm checkout configuration object
     */
    openCheckout(checkoutData) {
        if (!window.affirm || !window.affirm.ui) {
            console.error('Affirm SDK not loaded');
            alert('Affirm payment system is not available. Please try again or use a different payment method.');
            return;
        }

        //console.log('Opening Affirm checkout with data:', checkoutData);

        window.affirm.ui.ready(() => {
            window.affirm.checkout(checkoutData);
            window.affirm.checkout.open();
        });
    }
}